export default "__VITE_ASSET__B3q6r_Bn__"